import {gql} from "@apollo/client";

export const GET_SCHEDULE_INFO = gql`
	query GetSchedules ($filter: ScheduleInfoInput!) {
		scheduleInfo(input: $filter) {
			nextScheduleDates
		}
	}
`;
